import { render, staticRenderFns } from "./AccountSyncModal.vue?vue&type=template&id=20c6a96b&scoped=true&"
import script from "./AccountSyncModal.vue?vue&type=script&lang=js&"
export * from "./AccountSyncModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountSyncModal.vue?vue&type=style&index=0&id=20c6a96b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6a96b",
  null
  
)

export default component.exports